import Image from 'next/image';
import React from 'react';

interface IconProps {
    className?: string;
}

const MagIcon: React.FC<IconProps> = ({ className }) => {
    return (
        <Image className={className} src="/imgs/icon/Mag.webp" alt="Magazine Icon" width={24} height={24} />
    );
};

export default MagIcon;